import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Commercial } from './pages/Commercial';
import { SmartHome } from './pages/SmartHome';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Industries } from './pages/Industries';
import { Process } from './pages/Process';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Assessment } from './pages/Assessment';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route element={<Layout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/commercial" element={<Commercial data-id="element-7" />} data-id="element-6" />
          <Route path="/smart-home" element={<SmartHome data-id="element-9" />} data-id="element-8" />
          <Route path="/services" element={<Services data-id="element-11" />} data-id="element-10" />
          <Route path="/services/:slug" element={<ServiceDetail data-id="element-13" />} data-id="element-12" />
          <Route path="/industries" element={<Industries data-id="element-15" />} data-id="element-14" />
          <Route path="/process" element={<Process data-id="element-17" />} data-id="element-16" />
          <Route path="/about" element={<About data-id="element-19" />} data-id="element-18" />
          <Route path="/contact" element={<Contact data-id="element-21" />} data-id="element-20" />
          <Route path="/assessment" element={<Assessment data-id="element-23" />} data-id="element-22" />
          <Route path="*" element={<NotFound data-id="element-25" />} data-id="element-24" />
        </Route>
      </Routes>
    </BrowserRouter>;
}